<template>
  <component :is="compact ? 'div' : 'v-card'" flat>
    <component :is="compact ? 'div' : 'gg-card-title'" class="pb-0 pt-0">
      <gg-text-field
        v-model="search"
        append-icon="mdi-magnify"
        full-width
        hide-details
        clearable
        placeholder="Quick search"
        @input="emitData"
      />
    </component>
  </component>
</template>

<script>
export default {
  name: 'ServicesSearch',
  props: {
    compact: {
      type: Boolean,
      default: false,
    }
  },
  data () {
    return {
      search: '',
    }
  },
  methods: {
    emitData (value) {
      this.$emit('input', value)
    }
  }
}
</script>
